export const RecipientPickerLogic = {
  /**
   * The picker's way forward, counting who it takes: "Start Drafting · 3
   * people". With nobody picked there is nobody to count.
   */
  ctaLabel(count: number): string {
    if (count === 0) return 'Start Drafting';
    return `Start Drafting · ${count} ${count === 1 ? 'person' : 'people'}`;
  },
};
